// 3rd party imports
import * as React from 'react';

// bernie
import { withLocalization, LocalizedText } from 'bernie-l10n';

// ui
import { UitkCard } from 'uitk-react-cards';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkList, UitkListItem } from 'uitk-react-list';

// components
import { AffiliateCTA } from '../affiliate-cta';
import { LocalizedComponentProps } from '@shared-ui/localization-context';

export interface BenefitsProps extends LocalizedComponentProps {
  locale?: string;
}

@withLocalization
export class Benefits extends React.Component<BenefitsProps> {
  public render() {
    return (
      <>
        <UitkHeading tag="h2" size={3}>
          <LocalizedText message="home.benefits.heading.why_expedia_aff_program" />
        </UitkHeading>
        <UitkLayoutGrid className={'all-y-padding-six'} columns={{ medium: 3 }} space="three">
          <UitkLayoutGridItem>
            <UitkCard border={true} padded={true}>
              <UitkHeading tag="h3" size={4}>
                <LocalizedText message="home.benefits.cvp.heading.easily_earn" />
              </UitkHeading>
              <UitkText spacing="four">
                <LocalizedText message="home.benefits.cvp.content.make_money_every_time" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="home.benefits.cvp.content.help_optimize_content_cvr" />
              </UitkText>
            </UitkCard>
          </UitkLayoutGridItem>
          <UitkLayoutGridItem>
            <UitkCard border={true} padded={true}>
              <UitkHeading tag="h3" size={4}>
                <LocalizedText message="home.benefits.cvp.heading.access_inventory" />
              </UitkHeading>
              <UitkText spacing="four">
                <LocalizedText message="home.benefits.cvp.content.across_200_countries" />
              </UitkText>
              <UitkSpacing className="uitk-type-list-400" padding={{ block: 'three', inline: 'four' }}>
                <UitkList>
                  <UitkListItem key="listitem-1-1">
                    <LocalizedText message="home.benefits.cvp.content.175_plus_car_rentals" />
                  </UitkListItem>
                  <UitkListItem key="listitem-1-2">
                    <LocalizedText message="home.benefits.cvp.content.1mm_plus_hotels" />
                  </UitkListItem>
                  <UitkListItem key="listitem-1-3">
                    <LocalizedText message="home.benefits.cvp.content.35k_unique_activities" />
                  </UitkListItem>
                  <UitkListItem key="listitem-1-4">
                    <LocalizedText message="home.benefits.cvp.content.500_airlines" />
                  </UitkListItem>
                </UitkList>
              </UitkSpacing>
            </UitkCard>
          </UitkLayoutGridItem>
          <UitkLayoutGridItem>
            <UitkCard border={true} padded={true}>
              <UitkHeading tag="h3" size={4}>
                <LocalizedText message="home.benefits.cvp.heading.centralized_tools" />
              </UitkHeading>
              <UitkText spacing="four">
                <LocalizedText message="home.benefits.cvp.content.front_end_widgets" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="home.benefits.cvp.content.help_you_find_configure" />
              </UitkText>
            </UitkCard>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
        <UitkText align="center">
          <AffiliateCTA locale={this.props.locale} />
        </UitkText>
      </>
    );
  }
}
